/**
 * Created by stonewang on 2017/8/15.
 */
import React from 'react';

class ProductCustomer extends React.Component {

	render() {
		return (
            <div>
				{this.props.children}
			</div>
		)
	}
}
;
export default ProductCustomer;


// WEBPACK FOOTER //
// ./src/routes/productCustomer/index.js